import { getConfig } from "@cirrus/config"

export const withRoot = (relativeUrl) => {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = getConfig().ApiHost

  return base.concat(relativeUrl)
}
